import {createGrid} from "../../../helpers/grids/grids";
import createElement from "../../../helpers/createElement";
import {createCellRenderer} from "../../../helpers/grids/helpers";
import Axios from "axios";
import {handleAjaxSuccess, swalConfirm} from "../../../helpers/swalHelper";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../../helpers/loading";
import {ManageContractsModal} from "./ManageContractsModal/ManageContractsModal";

function initProductionAuditionContractsList() {
	// noinspection DuplicatedCode
	const grid = createGrid('.all-productions-audition-contracts-grid', {
			columnDefs: [
				{
					field: "name",
					headerName: 'Name',
					sortable: 'true',
					sort: 'asc',
				},
				{
					field: "type_display_name",
					headerName: 'Type',
					sortable: false,
				},
				{
					field: "is_signed",
					headerName: 'Signed',
					width: 120,
				},
				{
					field: "signed_at",
					headerName: 'Signed Date',
					sortable: true,
				},
				{
					field: "public_id",
					headerName: '',
					// maxWidth: 280,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable,UnnecessaryLocalVariableJS
						const buttons = createElement(`
                            <div class="buttons">
                            	<a class="btn btn-primary btn-sm ${!params.data.can_view ? 'd-none' : ''}"
									href="${params.data.view_url}">
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                    View
								</a>
								<a class="btn btn-info btn-sm reschedule-email-button">
                                    <i class="fa-solid fa-envelope"></i>
                                    Send Contract Email
								</a>
								<button class="btn btn-danger btn-sm delete-contract-button">
									 <i class="fa-solid fa-trash"></i>
									Delete
								</button>
                            </div>
							`
						)

						const rescheduleButton = buttons.querySelector('.reschedule-email-button');

						rescheduleButton.onclick =
							() => rescheduleEmail(params.data);


						const deleteButton = buttons.querySelector('.delete-contract-button');

						deleteButton.onclick =
							() => deleteContract(params.data);


						return buttons;
					})
				},
			],
			paginationPageSize: 20,
			_rowName: 'Audition Contract',
			rowClass: 'cursor-pointer',
		},
		window['routes/admin.productions.audition-contracts.productionAllContractsGrid'],
	);

	const manageContractsButton = document.querySelector('.manage-contracts-button');

	if (manageContractsButton) {
		manageContractsButton.addEventListener('click', () => {
			displayManageContractsModal(manageContractsButton.dataset.route);
		})
	}

	// noinspection DuplicatedCode
	/** Methods */
	function rescheduleEmail(contract) {
		swalConfirm({
			title: 'Are you sure you want to send contract notification email for this contract?'
		}).then(response => {
			if (response.isConfirmed) {
				loading();

				// noinspection JSUnresolvedVariable
				Axios.post(contract.resend_email)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		})

	}

	function deleteContract(contract) {
		swalConfirm({
			title: 'Are you sure you want to delete this contract?'
		}).then(response => {
			if (response.isConfirmed) {
				loading();

				// noinspection JSUnresolvedVariable
				Axios.post(contract.delete_url)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		})
	}

	function displayManageContractsModal(route) {
		new ManageContractsModal(
			route,
			{
				onSuccess() {
					grid._refresh();
				}
			}
		);
	}
}

export {
	initProductionAuditionContractsList
}
